import NsContent from 'components/common/ns-content/NsContent';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsList } from 'components/common/ns-list/NsList';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { useNavigation } from 'hooks/useNavigation';
import { Feature } from 'components/common/feature/Feature';
import { ToggleJourney } from 'components/app/routes/ToggleJourney';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMoveInSetup } from 'components/move-in/hooks/useMoveInSetup';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

export const testId = 'moveInTestId';

export const MoveIn = () => {
  useMoveInSetup();
  const { allowJourneyMoveIn } = useFlags();
  const { eventTypes, next } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  const handleBackBtnClick = () => {
    next({ eventType: eventTypes.BACK });
  };

  return (
    <Feature
      feature={allowJourneyMoveIn}
      inactiveComponent={<ToggleJourney off />}
    >
      <NsPanel testId={testId}>
        <span>
          <NsSecondaryCta icon="arrow-left" onClick={handleBackBtnClick}>
            Back
          </NsSecondaryCta>
        </span>
        <NsContent>
          <NsTitle title="Lets get you moved in" />
          <p>
            Relax - you&apos;re joining 8 million homes and businesses powered
            by British Gas. Your energy supply for your new home is in safe
            hands.
          </p>
          <NsList className="ul-bullet">
            {[
              `We give long term value - if you join us and we launch a cheaper fixed tariff, then you can change to it for free`,
              `If you have a smart meter, or get one installed, you can join our PeakSave scheme and get rewarded for better energy use.`
            ]}
          </NsList>
        </NsContent>
        <NsContent>
          <h2>A few things you will need:</h2>
          <NsList className="ul-bullet">
            {[
              `The date you got the keys`,
              `Your new address details`,
              `Your direct debit details (if you’d like to pay that way)`,
              `An up to date email address`
            ]}
          </NsList>
          <NsPrimaryCta onClick={handleGoNext}>Continue</NsPrimaryCta>
        </NsContent>
      </NsPanel>
    </Feature>
  );
};

export default MoveIn;
